

































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import _filter from 'lodash/filter'

import { IAssociation } from '@/models'

@Component( {
    computed: mapGetters( {
        currentImage: 'imagesModule/currentImage',
        userVotesByImageId: 'usersModule/userVotesByImageId',
        totalUsers: 'usersModule/totalUsers',
        currentUser: 'usersModule/currentUser',
        userHasFirstVote: 'usersModule/userHasFirstVote',
        associationById: 'associationsModule/associationById'
    } )
} )
export default class BaseAssociationPanel extends Vue {
    @Prop() associationId !: string
    @Prop() associationContent !: string
    @Prop() showStats !: boolean
    statsVisible = false

    userVotesByImageId!: any
    currentImage!: any
    totalUsers!: any
    currentUser!: any
    associationById!: any
    userHasFirstVote!: any

    get associationStats() {
        return this.userVotesByImageId( this.currentImage.id )
    }

    get firstVoteByCurrentUser() {
        return this.userHasFirstVote( this.associationId, this.currentImage.id )
    }

    get associationPercentage() {
        const countsByAssociationId = this.associationStats[this.associationId] ? this.associationStats[this.associationId] : 0

        return Math.round( ( 100 / this.totalUsers ) * countsByAssociationId )
    }

    get userHasVoted() {
        const existingVotes = this.currentUser.relatedVotes[this.currentImage.id]

        if ( existingVotes ) {
            return existingVotes.indexOf( this.associationId ) !== -1
        } else {
            return false
        }
    }

    @Watch( 'showStats' )
    setStatsVisible( value: boolean ) {
        this.statsVisible = value
    }

    associationVote( associationId: string, event: Event ) {
        const target = event.target as HTMLInputElement

        if ( target.checked ) {
            this.$store.dispatch( 'associationsModule/voteForAssociation', this.associationById( associationId ) )
        } else {
            this.$store.dispatch( 'associationsModule/removeVoteForAssociation', this.associationById( associationId ) )
        }
    }

    showAssociationDetail( event: Event ) {
        event.preventDefault()

        this.$parent.$emit( 'showAssociationDetail', this.associationId )
    }
}
